import { BASE_URL } from '../API/BASE_URL';

export const getPhoto = async (id) => {
  const response = await fetch(BASE_URL + `media/photos/`, {
    method: 'GET',
  });

  const data = await response.json();

  return data;
};
